import { render, staticRenderFns } from "./BaseTableList.vue?vue&type=template&id=672ee468&scoped=true&"
import script from "./BaseTableList.vue?vue&type=script&lang=js&"
export * from "./BaseTableList.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableList.vue?vue&type=style&index=0&id=672ee468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ee468",
  null
  
)

export default component.exports